import FileSaver from 'file-saver'
import ContentDisposition from 'content-disposition'

export default {
  methods: {
    downloadFile: function(response) {
      let disposition = ContentDisposition.parse(response.headers['content-disposition']);

      if (disposition && disposition.parameters && disposition.parameters.filename)
        FileSaver.saveAs(response.data, disposition.parameters.filename);
      else
        FileSaver.saveAs(response.data);
    }
  }
}